module.exports = __webpack_public_path__ + "media/images/icons/file_attachment-6e33ee090a6a34b90183869250abdc0f.svg";